// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-study-notes-wrap[data-v-eb362a88]{width:1200px;margin:0 auto;padding:10px 0 20px;-webkit-box-sizing:border-box;box-sizing:border-box;height:calc(100vh - 80px);display:-webkit-box;display:-ms-flexbox;display:flex}.new-study-notes-list[data-v-eb362a88]{background:#f3f3f3}", ""]);
// Exports
module.exports = exports;
